module.exports = __webpack_public_path__ + "85c563f385f257358cc451e5994b6ae0.jpg";